export default __webpack_public_path__ + "static/media/g_translate_icon.94c58387.svg";